import { Navigate, useOutletContext } from "react-router-dom";
import StudioIamSection from "../../../components/midpoint/clientViews/studio/StudioIamSection";
import { ClientViewIamApiProvider } from "../../../contexts/ClientViewIamApiContext";
import * as clientViewIamApi from "../../../api/clientViewIamApi";
import { useCasaMapaAdminPortal } from "../../../hooks/useCasaMapaAdminPortal";
import { useLocale } from "../../../intl";
import "../../../styles/clientViewStudio.css";

export default function CasaMapaAdminIamPage() {
  const { clientViewId } = useCasaMapaAdminPortal();
  const { permissions } = useOutletContext() || {};
  const { t } = useLocale();

  if (!clientViewId) {
    return (
      <div className="client-portal-page">
        <p className="empty-state">{t("realEstate.casaMapa.admin.errors.noViewMessage")}</p>
      </div>
    );
  }

  if (!permissions?.manageIam) {
    return <Navigate to="../dashboard" replace />;
  }

  return (
    <div className="client-portal-page cm-iam-page">
      <header className="cm-iam-page__header">
        <p className="cm-iam-page__eyebrow">{t("realEstate.casaMapa.admin.iam.eyebrow")}</p>
        <h1>{t("realEstate.casaMapa.admin.iam.title")}</h1>
        <p className="cm-iam-page__subtitle">{t("realEstate.casaMapa.admin.iam.subtitle")}</p>
      </header>

      <ClientViewIamApiProvider api={clientViewIamApi}>
        <StudioIamSection clientViewId={clientViewId} canManage variant="portal" />
      </ClientViewIamApiProvider>
    </div>
  );
}
